define('meeting-modal/country-selector/country-selector',['require','knockout','i18next','lib/countries/localize-and-sort-countries'],function (require) {
    var ko = require('knockout');
    var i18n = require('i18next');
    var localizeAndSortCountries = require('lib/countries/localize-and-sort-countries');

    var CountrySelector = function (availableCountries, savedCountries, selectorType) {
        var self = this;

        var sortedAvailableCountries = localizeAndSortCountries(availableCountries);

        // Either TOLL or TOLLFREE
        self.selectorType = selectorType;
        self.countrySearchQuery = ko.observable('');

        self.countrySearchResults = ko.computed(function () {
            return ko.utils.arrayFilter(sortedAvailableCountries, function (countryCode) {
                var country = i18n.t('countries.' + countryCode);
                return country.toLowerCase().indexOf(self.countrySearchQuery().toLowerCase()) > -1;
            });
        });

        self.selectedCountries = ko.observableArray(savedCountries)
            .extend({
                minLength: {
                    params: 1,
                    message: i18n.t('settings.overlay.required')
                }
            });

        self.sortedSelectedCountries = ko.computed(function () {
            return localizeAndSortCountries(self.selectedCountries());
        });

        /**
         * Writable computable:
         * Will return true if all countries are checked.
         *
         * Can be written to manually; setting to true will check all the countries,
         * setting to false will uncheck all the countries.
         */
        self.selectedAllCountries = ko.pureComputed({
            read: function () {
                return self.selectedCountries().length === sortedAvailableCountries.length;
            },
            write: function (isChecked) {
                self.selectedCountries(isChecked ? sortedAvailableCountries.slice(0) : []);
            }
        });

        self.compositionComplete = function () {
            /* Recenter modal is required because of the issue of not able to */
            /* see Save and Cancel on smaller resolutions */
            $(window).trigger('resize');
        };

        self.close = function () {
            /* Recenter modal is required because of the issue of not able to */
            /* see Save and Cancel on smaller resolutions */
            $(window).trigger('resize');
        };
    };

    return CountrySelector;
});

